module.exports = __webpack_public_path__ + "img/pexels-bongkarn-thanyakij-3843352.deb3bc43.jpg";